import { LevelGranulometryInitialEntries } from '../../LevelGranulometry';
import { CaseGranulometry } from '../../../cases/CaseGranulometry';
import { isGroundLevel } from '../is/isGroundLevel';

export const mustHaveAHallSection = (
  caseGranulometry: CaseGranulometry,
  levelGranulometry: LevelGranulometryInitialEntries
): boolean => isGroundLevel(levelGranulometry) && caseGranulometry.initialSpecifications.hall;
